import type { ReactNode, Ref } from "react";
import type { TextProps as AriaTextProps } from "react-aria-components";

import { Text as AriaText } from "react-aria-components";

import { cx } from "@/utils/cx";

interface HintTextProps extends AriaTextProps {
	children: ReactNode;
	/** Indicates that the hint text is an error message. */
	isInvalid?: boolean;
	ref?: Ref<HTMLElement>;
}

export const HintText = ({ className, isInvalid, ...props }: HintTextProps) => {
	return (
		<AriaText
			{...props}
			className={cx(
				"text-sm text-tertiary",

				// Invalid state
				isInvalid && "text-error-primary",
				"group-invalid:text-error-primary",

				className,
			)}
			slot={isInvalid ? "errorMessage" : "description"}
		/>
	);
};

HintText.displayName = "HintText";
